import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  AlertComponent: {
    position: 'relative',
    '&__counter': {
      border: `2px solid ${theme.palette.fontColor}`,
      borderRadius: '50%',
      color: theme.palette.fontColor,
      fontSize: '20px',
      fontWeight: 'bold',
      height: '40px',
      lineHeight: '36px',
      position: 'absolute',
      right: '-20px',
      textAlign: 'center',
      top: '-20px',
      width: '40px',
      zIndex: '2000',
    },
    '&__error-popup': {
      '&--color': {
        backgroundColor: theme.palette.error.dark,
      },
    },
    '&__icon': {
      '&--delete': {
        cursor: 'pointer',
        position: 'absolute',
        right: '20px',
        top: '20px',
        zIndex: 1402,
      },
    },
    '&__success-popup': {
      '&--color': {
        backgroundColor: theme.palette.success.dark,
      },
    },
    '&__warning-popup': {
      '&--color': {
        backgroundColor: theme.palette.warning.dark,
      },
    },
    '&__wrapper': {
      height: '150px',
      marginBottom: '10px',
      position: 'relative',
      width: '100%',
      zIndex: '1401 !important',
      '&__all': {
        bottom: '30px',
        minHeight: '150px',
        position: 'absolute',
        right: '60px',
        width: '300px',
        zIndex: 1400,
        '&--no-display': {
          display: 'none',
        },
      },
    },
  },
}));

export { useStyles };
